import { Close } from '@mui/icons-material';
import { ReactNode } from 'react';
import React from 'react';

export const CloseButton: React.FC<{ onClick: () => void; children?: ReactNode; isBlack?: boolean }> = ({
  onClick,
  children,
  isBlack = false,
}) => (
  <span
    className={`${isBlack ? '' : 'text-blue-600'} cursor-pointer rounded-sm h-fit hover:bg-light-blue`}
    onClick={onClick}
  >
    {children ? children : <Close />}
  </span>
);
